import base64 from "base-64";
import utf8 from "utf8";

export const appearanceThemesPayload = {
  image: {
    backgroundHeader: null,
    backgroundFooter: null,
  },
  color: {
    siteTitle: "",
    pageTitle: "",
    background: "",
    uiBackground: "",
    bodyText: "",
    link: "",
    linkHover: "",
    smallText: "",
    borderColor: "",
    primaryButtonBackground: "",
    primaryButtonText: "",
    primaryButtonHover: "",
    headerBackground: "",
    headerLink: "",
    footerBackground: "",
    footerText: "",
    footerLink: "",
    apiHubPrimary: "",
    apiHubSecondary: "",
  },
  fontSize: {
    siteTitle: "",
    pageTitle: "",
    sectionTitle: "",
    title: "",
    smallTitle: "",
    label: "",
    smallLabel: "",
    bodyText: "",
    smallText: "",
    footerText: "",
    buttonText: "",
  },
  typography: {
    siteTitle: "",
    pageTitle: "",
    bodyText: "",
    smallText: "",
    footerText: "",
    buttonText: "",
    apiHubFont: "",
  },
  label: {
    "service.publish.nav.manageapi.title": "",
    "service.publish.nav.apps.title": "",
    "service.publish.nav.apicatalog.title": "",
  },
  display: {
    versionNumber: true,
    copyright: true,
    apihubCopyright: true,
    cookieConsent: {
      enabled: false,
      message: "",
      position: "",
      theme: "",
    },
  },
  favicon: "",
  lastUpdated: "",
  logo: "",
  siteTitle: "",
}

export const DEFAULT_TYPOGRAPHY_OPTIONS = [
  { uuid: 'open-sans-regular', name: 'Open Sans Regular' },
  { uuid: 'open-sans-light', name: 'Open Sans Light' },
  { uuid: 'open-sans-semi-bold', name: 'Open Sans Semi Bold' },
  { uuid: 'open-sans-bold', name: 'Open Sans Bold' },
  { uuid: 'open-sans-extra-bold', name: 'Open Sans Extra Bold' },
  { uuid: 'clear-sans-regular', name: 'Clear Sans' },
  { uuid: 'ca-sans-regular', name: 'CA Sans Regular' },
  { uuid: 'ca-sans-light', name: 'CA Sans Light' },
  { uuid: 'ca-sans-bold', name: 'CA Sans Bold' },
  { uuid: 'helvetica', name: 'Helvetica' },
  { uuid: 'arial', name: 'Arial' },
];

export const validateAndSetErrors = (fieldType, fieldName, value, intl,
  setValidationErrorFromState) => {
  if (fieldType === "color" || fieldType === "fontSize") {
    const patterns = {
      fontSize: /^\d+(\.\d+)?(px|em)$/,
      color: /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6})$/,
    };

    const errorMessages = {
      fontSize: intl.getI18nMessage("label.appearance.form.font.size.invalid.format.error"),
      color: intl.getI18nMessage("label.appearance.form.color.invalid.format.error"),
    };

    const key = `${fieldType}.${fieldName}`;
    const isMatch = patterns[fieldType].test(value);

    setValidationErrorFromState(prevErrors => {
      if (isMatch) {
        const newErrors = { ...prevErrors };
        delete newErrors[key];
        return Object.keys(newErrors).length === 0 ? null : newErrors;
      } else {
        return {
          ...prevErrors,
          [key]: { localizedMessage: errorMessages[fieldType] },
        };
      }
    });
  }
};


export const getCookieMessage = (message) => {
  const text = utf8.decode(base64.decode(message));
  return text
    .replace(/<script>.*<\/script>/g, '')
    .replace(/javascript:([^"]+)/g, '')
    .replace(/(o|&#111;)(n|&#110;)[\S]*=([^)]+)/g, '');
};

const camelCaseCheck = /(?=[A-Z])/

export const convertToLabelFormat = (key) => {
  // This function converts the dynamic key into label format
  // Eg:- key = "label.appearance.edit.colors.siteTitle"
  // convertedKey = "label.appearance.edit.colors.site.title"
  const words = key.split(camelCaseCheck);
  return words.map(word => word.toLowerCase()).join(".");
};

export const convertToIdsFormat = (key) => {
  // This function converts the dynamic key into id's format
  // Eg:- key = "appearance-edit-colors-siteSitle"
  // convertedKey = "appearance-edit-colors-site-title"
  const words = key.split(camelCaseCheck);
  return words.map(word => word.toLowerCase()).join("-");
};

export const cookieConsentMessageBase64 = "PHA+T3VyIHNpdGUgdXNlcyBjb29raWVzPC9wPjxwPldlIHVzZSBjb29raWVzIHRvIGVuc3VyZSB5b3UgZ2V0IHRoZSBiZXN0IHBvc3NpYmxlIHVzZXIgZXhwZXJpZW5jZSBvbiBvdXIgd2Vic2l0ZS4gQnkgY29udGludWluZyB0byB1c2UgdGhpcyB3ZWJzaXRlLCB5b3UgY29uc2VudCB0byBvdXIgdXNlIG9mIHRoZXNlIGNvb2tpZXMuIEZvciBtb3JlIGluZm9ybWF0aW9uIGFib3V0IG91ciBkYXRhIHBvbGljaWVzLCB2aXNpdCA8YSBocmVmPSJodHRwczovL3d3dy5jYS5jb20vdXMvbGVnYWwvcHJpdmFjeS5odG1sIiB0YXJnZXQ9Il9ibGFuayI+IHByaXZhY3kgcG9saWN5PC9hPjwvcD4="